import { Drawer } from '@/components/shared/Drawer'
import AccountPopup from '.'

export default function PopupSettings({
    open,
    setOpen,
    initialTab = 'Account',
    onClose,
}: {
    open: boolean
    setOpen: (value: boolean) => void
    initialTab?: string
    onClose?: () => void
}) {
    return (
        <Drawer
            contentClassName="!pb-0"
            position="center"
            open={open}
            onOpenChange={(isOpen) => {
                setOpen(isOpen)
                if (!isOpen) onClose?.()
            }}
            triggerContent={null}
        >
            <AccountPopup
                onClose={() => {
                    setOpen(false)
                    onClose?.()
                }}
                initialTab={initialTab}
            />
        </Drawer>
    )
}
